import {
    Drawer,
    Input,
    Col,
    Select,
    Form,
    Button,
    Row,
    Spin
} from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import { useEffect, useLayoutEffect, useState } from 'react';
import { addPermissionsToRole } from '@/apiCalls/apiCalls';
import { errorNotification, successNotification } from '@/utils/Notification';
import RolePermissionListing from './RolePermissionListing';
import { Roles } from './RolesColumns';
import { useLocation, useNavigate } from 'react-router-dom';
import useAxiosPrivate from '@/context/UseAxiosPrivate';
import { Permissions } from '../permissions/PermissionsColumns';
import axios from 'axios';

const { Option } = Select;

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />
interface ProductsDrawerProps {
    showAddPermissionDrawer: boolean;
    setShowAddPermissionDrawer: React.Dispatch<React.SetStateAction<boolean>>;
    Roles: Roles
    getRoles: any
    roles: string[],
    setRolesData: React.Dispatch<React.SetStateAction<Roles | undefined>>;
}
const AddPermissionRoleDrawer: React.FC<ProductsDrawerProps> = ({ showAddPermissionDrawer, setShowAddPermissionDrawer, Roles, getRoles, roles, setRolesData }) => {
    const onCLose = () => {
        setRolesData(undefined)
        setShowAddPermissionDrawer(false)
    }
    const [submitting, setSubmitting] = useState(false)
    const [permissionsToDisplay, setPermissionsToDisplay] = useState<Permissions[]>([])
    const [permissionsOptions, setPermissionsOptions] = useState([])
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate();

    useLayoutEffect(() => {
        const setFormValues = async () => {
            form.setFieldsValue(Roles)
        }

        if (Roles) {
            setFormValues()
        }
    }, [Roles, form])




    const getPermissions = () => {

        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/permissions', {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: Permissions[]) => {
                if (isMounted) {
                    setPermissionsToDisplay(data);
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };



    useLayoutEffect(() => {
        getPermissions()
    }, [])

    useEffect(() => {
        const updatedPermissionsOptions: any = permissionsToDisplay.map((customer: any) => ({
            label: customer.name,
            value: customer.id
        }));
        setPermissionsOptions(updatedPermissionsOptions);
    }, [permissionsToDisplay])

    const filterPermissionsOptions = (inputValue: any, option: any) => {
        const label = option.props.children;
        if (label && typeof label === 'string') {
            return label.toLowerCase().includes(inputValue.toLowerCase());
        }
        return false;
    }
    const getClientIPAndURL = async () => {
        try {
            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }


    const onFinish = (roles: Roles) => {
        setSubmitting(true)
        let isMounted = true;
        const controller = new AbortController()
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivate.post('/api/v1/rolePermissions', roles, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then(() => {
            if (isMounted) {
                onCLose()
                successNotification(
                    "Roles successfully added",
                    `${roles.name} was added to the sytem`,
                    'topRight'
                )
            }
            getRoles()
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        }).finally(() => {
            setSubmitting(false)
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    const onFinishFailed = (errorInfo: any) => {
        alert(JSON.stringify(errorInfo, null, 2))
    }


    return <Drawer
        title={`Assign permissions to ROLE  ${Roles.name}`}
        width={720}
        onClose={onCLose}
        open={showAddPermissionDrawer}
        bodyStyle={{ paddingBottom: 80 }}
        style={{ backgroundColor: 'white' }}
        footer={
            <div
                style={{
                    textAlign: 'right',
                }}
            >
                <Button onClick={onCLose} style={{ marginRight: 8 }}>
                    Cancel
                </Button>
            </div>
        }
    >
        <Form layout="vertical"
            onFinishFailed={onFinishFailed}
            onFinish={onFinish}
            initialValues={Roles}
            form={form}
            hideRequiredMark>
            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        name="selectedPermisionsIds"
                        label="permissions"
                        rules={[{ required: true, message: 'Please slect customer name' }]}
                    >
                        <Select
                            placeholder="Please select customer name"
                            mode="multiple"
                            allowClear
                            showSearch
                            style={{ borderColor: 'black' }}
                            filterOption={filterPermissionsOptions}
                        >
                            {permissionsOptions.map((option: any) => (
                                <Option key={option.value} value={option.value}>{option.label}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <RolePermissionListing roleId={Roles.id} roles={roles} />
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" style={{ backgroundColor: 'green' }}>
                            Submit
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
            <Form.Item
                name="id"
                label="id"
                rules={[{ required: true, message: 'Please enter name' }]}
                hidden={true}
            >
                <Input
                    placeholder="Please enter name"
                    className='focus:border-green-500 hover:border-green-500'
                    
                />
            </Form.Item>
            <Row>
                {submitting && <Spin indicator={antIcon} />}
            </Row>
        </Form>
    </Drawer>
}

export default AddPermissionRoleDrawer;


